export function capitalizeFirstLetter(string: string) {
  const lowercase = string.toLowerCase();
  return lowercase.charAt(0).toUpperCase() + lowercase.slice(1);
}
